export default {"src":"/_next/static/media/close-with-shadow.592e0102.svg","height":40,"width":40};